import { z } from 'zod';
import { UUIDSchema, ISODateSchema } from './common';
import { CostCenterSchema } from './cost-center';
import { AssetStatusSchema, AssetUsageTypeSchema, ContactSchema, ExternalParticipantMailboxSchema, OrderStatusSchema, ReasonForValuationSchema, } from './order';
import { ValueOverviewAddressSchema, ValueOverviewStructureUsageTypeSchema } from './value-overview';
import { ValuationImageSchema, ValuationDocumentSchema } from './valuation';
import { ValuationStatusSchema, ValuationTypeSchema } from './valuation-primitives';
import { ImageWithContentTypeSchema } from './file';
import { MandatorSchema } from './mandator';
import { AppraiserAssignmentSchema } from './appraiser-assignment';
import { AppraisingEntitySchema, BaseUserSchema } from './user';
const OverviewCreatedBySchema = BaseUserSchema.pick({
    id: true,
    email: true,
    first_name: true,
    last_name: true,
    job_title: true,
}).extend({ team: z.string().optional() });
export const AppraiserOverviewCreatedBySchema = OverviewCreatedBySchema.extend({
    phone_number: BaseUserSchema.shape.phone_number,
});
const OverviewShape = {
    uuid: UUIDSchema,
    asset_state: AssetStatusSchema,
    asset_uuid: UUIDSchema.optional(),
    customer_asset_reference: z.string().optional(),
    cost_center: CostCenterSchema.optional(),
    valuation_uuid: UUIDSchema.optional(),
    valuation_title: z.string().optional(),
    status: OrderStatusSchema,
    status_message: z.string().optional(),
    address: ValueOverviewAddressSchema,
    asset_image_url: z.string().optional(),
    asset_thumbnail_image_url: z.string().optional(),
    documents: z.array(ValuationDocumentSchema),
    order_date: ISODateSchema.optional(),
    due_date: ISODateSchema.optional(),
    valuation_date: ISODateSchema.optional(),
    inspection_date: ISODateSchema.optional(),
    quality_assessment_date: ISODateSchema.optional(),
    report_date: ISODateSchema.optional(),
    valuation_reason: ReasonForValuationSchema.optional(),
    contacts: z.array(ContactSchema),
    mandators: z.array(MandatorSchema),
    note: z.string().optional(),
    assigned_customer_users: z.array(z.number()),
    drafts: z.array(UUIDSchema),
    service_provider: AppraisingEntitySchema.optional(),
    appraiser_assignment: AppraiserAssignmentSchema.optional(),
    external_appraising_entity_name: z.string().optional(),
    observers: z.array(UUIDSchema),
};
const OverviewSchema = z.object(OverviewShape);
export const AppraiserOrderOverviewSchema = OverviewSchema.extend({
    customer_uuid: UUIDSchema,
    valuation_status: ValuationStatusSchema,
    asset_usage_types: z.array(AssetUsageTypeSchema).optional(),
    asset_title: z.string().optional(),
    valuation_type: ValuationTypeSchema.optional(),
    images: z.array(ValuationImageSchema),
    created_by: AppraiserOverviewCreatedBySchema,
});
const PortalOverviewUsageSchema = z.object({
    usage_type: z.union([ValueOverviewStructureUsageTypeSchema, z.literal('unknown')]),
    sub_usage_type: z.string().optional(),
});
export const ClientPortalOrderOverviewSchema = OverviewSchema.extend({
    customer_uuid: UUIDSchema.optional(),
    valuation_status: ValuationStatusSchema.optional(),
    asset_usage_types: z.array(PortalOverviewUsageSchema).optional(),
    valuation_report_url: z.string().optional(),
    images: z.array(ImageWithContentTypeSchema),
    created_by: OverviewCreatedBySchema,
    external_participant_mailbox: ExternalParticipantMailboxSchema.nullable().optional(),
});
export const PendingOrderOverviewSchema = ClientPortalOrderOverviewSchema.pick({
    cost_center: true,
    status: true,
    address: true,
    customer_asset_reference: true,
    contacts: true,
    mandators: true,
    created_by: true,
});
const AppraiserOrderOverviewsShape = {
    orders: z.array(AppraiserOrderOverviewSchema),
};
export const AppraiserOrderOverviewsSchema = z.object(AppraiserOrderOverviewsShape);
const ClientPortalOrderOverviewsShape = { orders: z.array(z.union([ClientPortalOrderOverviewSchema, PendingOrderOverviewSchema])) };
export const ClientPortalOrderOverviewsSchema = z.object(ClientPortalOrderOverviewsShape);
